import type React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import Button from 'app/ui/components/atoms/button';

interface CarouselButtonsProps {
  onNext: () => void;
  onPrevious: () => void;
  isFirst?: boolean;
  isLast?: boolean;
  onDone?: () => void;
}

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme: { spacing } }) => spacing(2)};
  width: 100%;
  justify-content: flex-end;

  button {
    flex: 1;
    max-width: 50%;
    
    ${({ theme: { media } }) => `
      ${media.medium(
        () => `
          flex: unset;
          max-width: none;
        `,
      )}
    `}
  }
`;

export const CarouselButtons: React.FC<CarouselButtonsProps> = ({
  onNext,
  onPrevious,
  isFirst = false,
  isLast = false,
  onDone,
}) => {
  const intl = useIntl();

  const handleAction = () => {
    if (isLast && onDone) {
      onDone();
    } else {
      onNext();
    }
  };

  return (
    <ButtonWrapper>
      {!isFirst && (
        <Button
          type="secondary-white"
          onClick={onPrevious}
          label={intl.formatMessage({ id: 'carouselModal.buttons.back' })}
        />
      )}
      <Button
        type="primary"
        onClick={handleAction}
        label={intl.formatMessage({
          id: isLast ? 'carouselModal.buttons.done' : 'carouselModal.buttons.next',
        })}
      />
    </ButtonWrapper>
  );
};
